import MenuItem from "@mui/material/MenuItem";
import { CircularProgress, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { shareCampaignApi, useDeleteUserFromCampaignMutation } from "api";
import { useAppDispatch } from "hooks";
import { CustomToast } from "../../CustomToast";
import { MoreVertIcon } from "../../../images/MoreVertIcon";
import { StyledMenu } from "../../StyledMenu";
import { getErrorMessage } from "../../../../utils/getErrorMessage";

export const SharedUserMenu = ({
  campaign_id,
  user_email,
  isDisabled,
}: {
  campaign_id: string;
  user_email: string;
  isDisabled: boolean;
}) => {
  const dispatch = useAppDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [deleteUserFromCampaign, { error, isLoading }] =
    useDeleteUserFromCampaignMutation();

  useEffect(() => {
    if (error) {
      toast.error(
        <CustomToast
          type={"error"}
          text={`Something went wrong during the discard of . Please try again`}
          title={"Failed remove user"}
        />,
      );
    }
  }, [error]);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const removeUserHandler = () => {
    deleteUserFromCampaign({ campaign_id, user_email })
      .unwrap()
      .then(() => {
        dispatch(shareCampaignApi.util.invalidateTags(["shared-users"]));
        setAnchorEl(null);
      })
      .catch((err) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong during processing. Please try again"
            }
            title={"Failed to Remove User"}
          />,
        );
      });
  };

  return (
    <div>
      <IconButton
        disabled={isDisabled}
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon width="24" />
      </IconButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "white",
          },
        }}
      >
        <MenuItem
          disabled={isLoading}
          sx={{ display: "flex", gap: "12px", alignItems: "center" }}
          onClick={removeUserHandler}
        >
          Remove{" "}
          {isLoading && (
            <CircularProgress size={24} sx={{ color: "inherit" }} />
          )}
        </MenuItem>
      </StyledMenu>
    </div>
  );
};
